import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import  Templates  from '../layouts/Templates';
import SampleImage from '../images/xile.png'

const Party = ({ data,pageContext }) => {
  const category = "food";
  const title1 = 'food一覧';
  const title2 = '喜乐小店';
  
  const content = <>
                      欢迎光临<br />
                      喜乐小店<br />
                      香港长洲岛
                  </>
                  ;

  return (
    <Templates
      category={category}
      title1={title1} 
      title2={title2} 
      headerContent={content} 
      image={SampleImage} 
      data={data} 
      pageContext={pageContext}
      />
  );
};

export default Party;

Party.propTypes = {
  pageContext:PropTypes.object.isRequired,
  data:PropTypes.object.isRequired,
}

export const query = graphql`
  query($skip: Int!, $limit: Int!) {
    allContentfulFood(
      skip: $skip
      limit: $limit
    ){
      edges{
        node{
            id
          Name
          path
          price
          release
          tags{
            tag
          }
          text {
            json
          }
          mainpic{
            fluid(maxWidth:1000,quality:90){
              ...GatsbyContentfulFluid
            }
            title
          }
        }
      }
      totalCount
    }
  }
`;
